// noinspection JSUnusedGlobalSymbols

import { get } from '../utils/utils';

const contentTheme = {
  data: {
    gmapmarker: {
      eurostarshotels: '/assets/icons/gmapmarker.png',
      exehotels: '/assets/icons/gmapmarker.png'
    },
    goldLoading: {
      eurostarshotels: '/assets/icons/gold_loader.gif',
      exehotels: '/assets/icons/exe_loader.gif'
    },
    color: {
      eurostarshotels: '#c94',
      exehotels: '#a6192e'
    }
  },
  getter: theme => {
    return {
      /**
       * Returns amenity by code
       * If code not found returns an empty string
       *
       * @param {string} code
       * @returns {string}
       */
      getContentTheme(code) {
        return (
          (contentTheme.data[code] &&
            (get(theme, contentTheme.data[code]) ||
              get(Object.keys(contentTheme.data[code])[0], contentTheme.data[code]))) ||
          null
        );
      }
    };
  }
};

export default contentTheme;
